// ClientSelect.js
// Component for Client Selector

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Button } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';

// Component Class
// Shows Client Selector
class ClientSelect extends React.Component {
  // Returns the name for the given client
  getClientName = (id) => {
    if (!id) return "";
    return this.props.clients.byId[id].name;
  }

  // Predicate for typeahead queries
  predicate = (query, id) => {
    var name = this.getClientName(id);
    return name.toLowerCase().includes(query.toLowerCase());
  }

  // Returns a list of filtered client ids
  getFilteredIds = () => {
    var filtered = [];
    for (var i = 0; i < this.props.clients.ids.length; i++) {
      var id = this.props.clients.ids[i];
      if (this.filter(id))
        filtered.push(id);
    }
    return filtered;
  }

  // Returns whether a given client id belongs in the list
  filter = (clientId) => {
    if (!this.props.filter)
      return true;
    return this.props.filter(clientId);
  }

  // Renders a client item
  itemRenderer = (id, options) => {
    if (!options.modifiers.matchesPredicate) {
      return null;
    }

    return (
      <MenuItem
        active={options.modifiers.active}
        onClick={options.handleClick}
        key={id}
        text={this.getClientName(id)}
      />
    );
  };

  // Renders Component
  render() {
    var items = this.getFilteredIds();
    var selected = this.props.selected && this.filter(this.props.selected) ? 
                   this.props.selected : items[0];
    return (
      <Select
        value={selected}
        items={items}
        itemRenderer={this.itemRenderer}
        inputValueRenderer={this.getClientName}
        itemPredicate={this.predicate}
        onItemSelect={this.props.setClient}
        disabled={items.length === 0}
      >
        <Button 
          text={selected ? this.getClientName(selected) : "Sem Clientes com Pedido"}
          rightIcon="double-caret-vertical"
          disabled={items.length === 0}
          fill
        />
      </Select>
    );
  }
}

// Required Properties
ClientSelect.propTypes = {
  selected: PropTypes.number,
  filter: PropTypes.func,
  clients: PropTypes.object.isRequired,
  setClient: PropTypes.func.isRequired,
}

// Exports
export default ClientSelect;


// WEBPACK FOOTER //
// ./src/components/ReportView/ClientSelect.js